import styled from 'styled-components';
import { FiMinus, FiPlus } from 'react-icons/fi';

import FlowHeaderButton from './FlowHeaderButton';
import Input from 'components/ui/Input';
import useZoom from '../hooks/useZoom';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const InputView = styled.div`
  position: relative;
  top: -1px;
  display: flex;
  align-items: center;
  gap: 2px;

  input {
    text-align: center;
    width: 24px;
    padding: 0;
    margin: 0;
    border: none !important;
    outline: none !important;
    height: 16px;
    font-size: 13px;
  }
  span {
    position: relative;
    top: 1px;
    font-size: 11px;
    font-weight: 700;
    color: ${(props) => props.theme.global.lightTextColor};
  }
`;

const ZoomController = () => {
  const { zoom, onZoomIn, onZoomOut, onInputKeydown, onZoomChange, onZoomTo } = useZoom();
  return (
    <Container>
      <FlowHeaderButton id="zoom-out" Icon={FiMinus} onClick={onZoomOut} />
      <InputView>
        <Input value={zoom} onChange={onZoomChange} onBlur={onZoomTo} onKeyDown={onInputKeydown} />
        <span>{`%`}</span>
      </InputView>
      <FlowHeaderButton id="zoom-in" Icon={FiPlus} onClick={onZoomIn} />
    </Container>
  );
};

export default ZoomController;
